// @flow
import React, { Component, Fragment } from 'react';
import { isBrowser } from 'react-device-detect';
import type { State } from 'store';
import { connect } from 'react-redux';
import EstimateTable from 'components/estimate/EstimateTable/EstimateTable';
import { type UserData } from 'store/modules/user';
import { EstimateActions, UserActions } from 'store/actionCreators';
import { getEstimate, type UploadInfo } from 'store/modules/estimate';
import axios from 'axios';
import storage, { keys } from 'lib/storage';
import Button from 'components/common/Button';
import './EstimateTableContainer.scss';

type Props = {
  user: ?UserData,
  estimate: ?getEstimate,
  uploadInfo: ?UploadInfo,
};

class EstimateTableContainer extends Component<Props> {
  initialize = () => {
    const { user, id } = this.props;
    if (!user) return;
    EstimateActions.getEstimate(user.username);
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.user && this.props.user) {
      this.initialize();
    }
  }

  uploadFile = async (file: any) => {
    if (file.size > 1024 * 1024 * 10) return;
    // const fileTypeRegex = /^image\/(.*?)/;
    // if (!fileTypeRegex.test(file.type)) return;
    // if (file.type.indexOf('gif') > 0) return;
    try {
      // const filename = escapeForUrl(file.name);
      await EstimateActions.createEstimateSignedUrl(file.name);
      if (!this.props.uploadInfo) return;
      const { url, file_path: filePath } = this.props.uploadInfo;
      await axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
        withCredentials: false,
        onUploadProgress: e => {
          if (window.nanobar) {
            window.nanobar.go((e.loaded / e.total) * 100);
          }
        },
      });
      // 리스트 불러 오기
      this.initialize();
      await UserActions.checkUser();
      storage.set(keys.user, this.props.user);
    } catch (e) {
      console.log(e);
    }
  };

  onUploadEstimate = () => {
    const upload = document.createElement('input');
    upload.type = 'file';
    upload.onchange = e => {
      if (!upload.files) return;
      const file = upload.files[0];
      this.uploadFile(file);
    };
    upload.click();
  };

  onRemoveEstimate = async id => {
    const { user } = this.props;
    if (!user) return;
    try {
      await EstimateActions.removeEstimate(user.username, id);
    } catch (e) {
      console.log(e);
    }
  };

  onUpdateEstimate = async (id, idx) => {
    const { user } = this.props;
    if (!user) return;
    try {
      await EstimateActions.updateEstimate(user.username, id, idx);
    } catch (e) {
      console.log(e);
    }
  };

  onViewEstimate = async id => {
    const { user } = this.props;
    if (!user) return;
    try {
      await EstimateActions.selectEstimateBox(user.username, id);
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { estimate } = this.props;

    return (
      <Fragment>
        <div className="upload-menu">
          <Button onClick={() => this.onUploadEstimate()} desktop={isBrowser}>
            업로드
          </Button>
          <Button
            onClick={() => window.open('https://images.cacheby.com/estimate/Quotation_V1.04.xlsx')}
            desktop={isBrowser}
          >
            요청 양식 다운로드
          </Button>
        </div>
        {estimate && (
          <EstimateTable
            estimate={estimate}
            onUploadEstimate={this.onUploadEstimate}
            onRemoveEstimate={this.onRemoveEstimate}
            onUpdateEstimate={this.onUpdateEstimate}
            onViewEstimate={this.onViewEstimate}
          />
        )}
        {/* {estimate && estimate.data.length === 0 && <div>견적 요청 내역이 없습니다.</div>} */}
      </Fragment>
    );
  }
}

export default connect(
  ({ user, estimate }: State) => ({
    user: user.user,
    estimate: estimate.estimate,
    uploadInfo: estimate.uploadInfo,
  }),
  () => ({}),
)(EstimateTableContainer);



// WEBPACK FOOTER //
// ./src/containers/estimate/EstimateTableContainer.js